import {
  Box,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import getLaborSummary from "../../../../../service/laborSummary";

const LaborSummary = ({ order, ...props }) => {
  let laborSummary = getLaborSummary(order);

  if (order && laborSummary)
    return (
      <Box {...props}>
        <Typography variant="h6">Labor Summary</Typography>
        <TableContainer component={Paper} sx={{ marginTop: "8px" }}>
          <Table sx={{ minWidth: 300 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell>TOTAL Labor Hours to Complete Job</TableCell>
                <TableCell align="right">{laborSummary.totalHours}</TableCell>
              </TableRow>

              {laborSummary.panelHours && (
                <TableRow>
                  <TableCell>Panel Hours</TableCell>
                  <TableCell align="right">{laborSummary.panelHours}</TableCell>
                </TableRow>
              )}
              {laborSummary.trimHours && (
                <TableRow>
                  <TableCell>Trim & Flashing Hours</TableCell>
                  <TableCell align="right">{laborSummary.trimHours}</TableCell>
                </TableRow>
              )}

              {laborSummary.copingCapHours && (
                <TableRow>
                  <TableCell>Coping Cap Hours</TableCell>
                  <TableCell align="right">
                    {laborSummary.copingCapHours}
                  </TableCell>
                </TableRow>
              )}
              {laborSummary.cleatHours && (
                <TableRow>
                  <TableCell>Cleat Hours</TableCell>
                  <TableCell align="right">{laborSummary.cleatHours}</TableCell>
                </TableRow>
              )}

              {laborSummary.benchWorkHours && (
                <TableRow>
                  <TableCell>Bench Work Hours</TableCell>
                  <TableCell align="right">
                    {laborSummary.benchWorkHours}
                  </TableCell>
                </TableRow>
              )}

              {laborSummary.splicePlateHours && (
                <TableRow>
                  <TableCell>Splice Plate Hours</TableCell>
                  <TableCell align="right">
                    {laborSummary.splicePlateHours}
                  </TableCell>
                </TableRow>
              )}
            </TableHead>
          </Table>
        </TableContainer>
      </Box>
    );
};

export default LaborSummary;
